/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './style/bolmateRadio.scss';

import classNames from 'classnames';
import React, {MouseEventHandler} from 'react';

interface Props {
    onSelect: MouseEventHandler;
    selected: boolean;
    disabled?: boolean;
    className?: string;
    label?: string;
}

export default function BolmateRadio(props: Props) {
    const {selected, onSelect, className, disabled, label} = props;

    function renderBullet() {
        return (
            <div className='bolmate-radio-bullet-container'>
                <span className={classNames('bolmate-radio-bullet', selected && 'active')}/>
            </div>
        )
    }

    function renderLabel() {
        if (!label) return null;
        return <label className='bolmate-radio-label'>{label}</label>
    }

    return (
        <div className={classNames('bolmate-radio', disabled && 'disabled', className)}
             onClick={disabled ? undefined : onSelect}>
            {renderBullet()}
            {renderLabel()}
        </div>
    )
}